export var HEADER_HEIGHT = '7.4rem';